var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 40,
    viewBox: "0 0 74 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.159 19.8345L38.1068 21.937C42.9426 16.7097 42.9426 8.22967 38.1068 3L36.159 5.1025C37.9667 7.05758 38.9817 9.70625 38.9817 12.4685C38.9817 15.2307 37.9667 17.8818 36.159 19.8345ZM32.2658 15.6247L34.2112 17.7296C36.8985 14.8223 36.8985 10.1122 34.2112 7.20742L32.2658 9.31475C33.8753 11.0572 33.8753 13.8822 32.2658 15.6222V15.6247ZM11.306 13.4037C11.306 8.62358 15.2887 4.77625 20.1655 4.77625C25.0423 4.77625 29.025 8.62358 29.025 13.4037C29.025 18.1863 25.0423 22.0312 20.1655 22.0312C15.2887 22.0312 11.306 18.1863 11.306 13.4037ZM44.975 13.4037C44.975 8.62358 48.9577 4.77625 53.8345 4.77625C58.7113 4.77625 62.694 8.62358 62.694 13.4037C62.694 18.1863 58.7113 22.0312 53.8345 22.0312C48.9577 22.0312 44.975 18.1863 44.975 13.4037ZM8 36.669C8 30.1126 13.4617 24.8249 20.1655 24.8249C26.8693 24.8249 32.331 30.1102 32.331 36.6666V37.2611H8V36.669ZM41.669 36.669C41.669 30.1126 47.1307 24.8249 53.8345 24.8249C60.5383 24.8249 66 30.1102 66 36.6642V37.2587H41.669V36.669Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOne);
export default __webpack_public_path__ + "static/media/icon_audio_one.9ae6b3f9406085f526c130aec855a2cc.svg";
export { ForwardRef as ReactComponent };